import Create from './create/CreateAccount';
import Edit from './edit/EditAccount';
import Individual from './individual/Account';
import List from './list/Accounts';

export default { List, Individual, Create, Edit };
